<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Driver"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedDrivers"
      :columns="columns"
      :total-rows="totalDrivers"
      :get-edit-url="getEditUrl"
    >
      <template #actions="{ row }">
        <q-td class="q-pa-none text-center">
          <q-btn
            size="sm"
            color="primary"
            label="Edit"
            @click="$router.push(getEditUrl(row))"
            class="q-mr-sm"
          />
          <q-btn
            size="sm"
            :color="row.is_active ? 'negative' : 'positive'"
            :label="row.is_active ? 'Deactivate' : 'Reactivate'"
            @click="toggleActive(row)"
          />
        </q-td>
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'DriverTable',
  components: {
    BaseTable
  },
  data() {
    return {
      drivers: [],
      totalDrivers: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'hauler_name', align: 'left', label: 'Hauler', field: 'hauler_name', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedDrivers() {
      return this.drivers.map(driver => ({
        ...driver,
        hauler_name: driver.hauler_id?.name || 'N/A',
        add_date: new Date(driver.add_date).toLocaleDateString(),
        edit_date: new Date(driver.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchDrivers();
  },
  methods: {
    fetchDrivers() {
      axios
        .get('/api/v1/driver/drivers/', { params: { show_inactive: true } })
        .then(response => {
          console.log(response.data);
          this.drivers = response.data;
          this.totalDrivers = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching drivers:', error);
        });
    },
    onAdd() {
      this.$router.push('/driver/add');
    },
    getEditUrl(row) {
      return `/driver/edit/${row.id}`;
    },
    toggleActive(row) {
      axios
        .patch(`/api/v1/driver/drivers/${row.id}/`, { is_active: !row.is_active })
        .then(() => {
          this.$q.notify({
            color: 'green',
            message: `Driver ${row.is_active ? 'deactivated' : 'reactivated'}.`,
            icon: 'check'
          });
          this.fetchDrivers();
        })
        .catch(error => {
          console.error('Error updating driver active state:', error);
          this.$q.notify({
            color: 'red',
            message: 'Failed to update driver status.',
            icon: 'error'
          });
        });
    }
  },
  watch: {
    drivers() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the DriverTable here */
</style>
